import { Back, Power1, TweenMax } from 'gsap';
import { Sprite } from 'pixi.js';
import { getGameSize, IGameSizeInfo } from '../../Config/Levels';
import { gameConfig } from '../../index';
import { HudActions, HudEmitter } from '../../Managers/Hud/HudEmitter';
import { waitForMs } from '../../Utils/AsyncUtils';
import { createOutlineText, createPixiText } from '../../Utils/Utils';
import { TextButton } from '../Shared/Buttons/TextButton';
import { UIButton } from '../Shared/Buttons/UIButton';
import { ITweenable } from './ITweenable';
import { Popup } from '../../Managers/Popups';
import { ButtonColors } from '../Shared/Buttons/NineSliceButton';

export class RewardPopup extends PIXI.Container implements ITweenable {
    private popupType: Popup;
    private bg: PIXI.Sprite;
    private char: PIXI.Sprite;
    private popup: PIXI.Sprite;
    private banner: PIXI.Sprite;
    private close: UIButton;
    private msg: PIXI.Text;
    private stuff: PIXI.Sprite;
    private description: PIXI.Text;
    private group: PIXI.Sprite;
    private getBtn: TextButton;
    private notNow: TextButton;

    constructor(
        characterIcon: string,
        icon: string,
        headerText: string,
        messageText: string,
        confirmText: string,
        dismissText: string,
        popupType: Popup
    ) {
        super();

        this.popupType = popupType;

        const gameSize: IGameSizeInfo = getGameSize();

        const bg = new PIXI.Sprite(PIXI.utils.TextureCache['loading/win-bg']);
        let bScale = gameSize.gameWidth / bg.width;
        if (bg.height * bScale < gameSize.gameHeight) {
            bScale = gameSize.gameHeight / bg.height;
        }
        bg.scale.set(bScale);
        bg.x = (gameSize.gameWidth - bg.width) / 2;
        bg.y = (gameSize.gameHeight - bg.height) / 2;
        bg.alpha = 0;
        bg.interactive = true;
        this.bg = bg;

        const group = new PIXI.Sprite();

        const char = new PIXI.Sprite(PIXI.utils.TextureCache[characterIcon]);
        char.anchor.set(0.5, 0);
        char.x = gameSize.gameWidth / 2;
        char.y = gameSize.yOffset + gameConfig.game_height * 0.01;
        char.alpha = 0;

        const header = new Sprite(PIXI.utils.TextureCache['commonui/header']);
        header.anchor.set(0.5, 0.5);
        header.x = gameSize.gameWidth / 2;
        header.y = char.y + char.height;
        header.scale.set(0);

        // popup bg
        const texture = PIXI.utils.TextureCache['commonui/popup-bg'];
        const nine = new PIXI.mesh.NineSlicePlane(texture, 100, 100, 100, 100);
        nine.width = gameConfig.game_width * 0.87;
        nine.height = gameConfig.game_height * 0.7;
        const popup = new PIXI.Sprite();
        popup.anchor.set(0.5);
        popup.addChild(nine);
        popup.x = gameSize.gameWidth / 2 - nine.width / 2;
        popup.y = gameSize.gameHeight / 2 - nine.height * 0.4;

        const msg = createOutlineText(
            headerText,
            new PIXI.Rectangle(
                gameSize.gameWidth * 0.5,
                header.y - header.height * 0.05,
                gameConfig.game_width * 0.8,
                header.height * 0.4
            ),
            'Baloo',
            45,
            35,
            0xffffff,
            0x991f33
        );
        msg.scale.set(0);
        this.msg = msg;

        // close btn
        const closeButton = new UIButton('commonui/button-close');
        closeButton.bg.anchor.set(1, 0);
        closeButton.x = gameSize.gameWidth / 2 + gameConfig.game_width * 0.4;
        closeButton.y = popup.y;
        closeButton.on('trigger', () => {
            const out = this.tweenOut('close');
            out.catch(() => {});
        });

        const stuff = new Sprite(PIXI.utils.TextureCache[icon]);
        stuff.anchor.set(0.5);
        stuff.alpha = 0;
        stuff.scale.set(0.5);
        stuff.x = gameSize.gameWidth / 2;
        stuff.y = header.y + header.height + stuff.height * 0.9;

        /*const descriptionText = createBitmapText(
            Core.local.getText('subscribetext'),
            new PIXI.Rectangle(0, 0, gameConfig.game_width * 0.75, gameConfig.game_height),
            'riffic'
        );*/
        /*     const message = Core.local.getText('addShorcutMessage') + '\n' +
                 Core.local.getText('reward') + ': 500 ' + Core.local.getText('coins');*/
        const descriptionText = createPixiText(
            messageText,
            new PIXI.Rectangle(0, 0, gameConfig.game_width * 0.75, gameConfig.game_height),
            'Baloo'
        );
        descriptionText.anchor.set(0.5);
        descriptionText.x = gameSize.gameWidth / 2;
        descriptionText.y = stuff.y + stuff.height;

        const getBtn = new TextButton({
            width: nine.width * 0.4,
            height: gameConfig.game_height * 0.12,
            btnText: confirmText,
        });
        getBtn.x = gameSize.gameWidth / 2 + nine.width * 0.2;
        getBtn.y = stuff.y + stuff.height * 1.65;

        const notNow = new TextButton({
            width: nine.width * 0.4,
            height: gameConfig.game_height * 0.12,
            btnText: dismissText,
            color: ButtonColors.ORANGE,
        });
        notNow.x = gameSize.gameWidth / 2 - nine.width * 0.2;
        notNow.y = getBtn.y;

        group.addChild(
            popup,
            char,
            header,
            msg,
            //@ts-ignore
            closeButton,
            stuff,
            descriptionText,
            getBtn,
            notNow
        );
        this.addChild(bg, group);

        this.bg = bg;
        this.char = char;
        this.popup = popup;
        this.banner = header;
        this.close = closeButton;
        this.msg = msg;
        this.stuff = stuff;
        this.description = descriptionText;
        this.getBtn = getBtn;
        this.notNow = notNow;
        this.group = group;

        this.getBtn.once('trigger', () => {
            const out = this.tweenOut('confirm');
            out.catch(() => {});
        });

        this.notNow.once('trigger', () => {
            const out = this.tweenOut('not now');
            out.catch(() => {});
        });

        const ready = this.tweenIn();
        ready.catch(() => {});
    }

    public async tweenIn() {
        // bg fade in
        TweenMax.to(this.bg, 0.3, {
            alpha: 0.7,
            onComplete: () => {
                // this.bg.cacheAsBitmap = true;
            },
        });
        await waitForMs(300);

        // popup scale out
        TweenMax.to(this.popup.scale, 0.4, { x: 1, y: 1, ease: Back.easeOut });

        await waitForMs(0.4);

        TweenMax.to(this.char, 0.4, { alpha: 1 });
        TweenMax.to(this.banner.scale, 0.4, { x: 1, y: 1, ease: Back.easeOut });
        TweenMax.to(this.msg.scale, 0.4, { x: 1, y: 1, ease: Back.easeOut });

        await waitForMs(0.4);

        // fade in stuff
        TweenMax.to(this.stuff, 0.4, { alpha: 1 });
        TweenMax.to(this.stuff.scale, 0.4, { x: 0.9, y: 0.9, ease: Back.easeOut });
        TweenMax.to(this.description, 0.4, { alpha: 1 });

        // scale in button

        TweenMax.to(this.close.scale, 0.4, { x: 1, y: 1, ease: Back.easeOut });
        await waitForMs(0.4);
    }

    public async tweenOut(to: string) {
        TweenMax.to(this.group, 0.6, { y: getGameSize().gameHeight, ease: Back.easeIn });
        TweenMax.to(this, 0.6, {
            alpha: 0,
            delay: 0.3,
            ease: Power1.easeIn,
            onComplete: () => {
                // args
                HudEmitter.instance.emit(HudActions.CLOSE_POPUP, this.popupType, 0, to);
                this.destroy();
            },
        });

        return;
    }
}
